import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Recetas de internet que no explican bien', 'Budines que quedan secos o duros', 'Ingredientes complicados', 'Resultados que no se parecen a las fotos'];
  return <section className="py-20 px-4" data-id="element-184">
      <div className="max-w-4xl mx-auto" data-id="element-185">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#3D2B1F]" data-id="element-186">
          ¿Te gustaría preparar budines caseros deliciosos, pero{' '}
          <span className="text-red-500" data-id="element-187">siempre pasa lo mismo?</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-188">
          {problems.map((problem, index) => <div key={index} className="bg-white p-6 rounded-2xl border border-red-200 flex items-center gap-4 transform transition-all hover:-translate-y-1 hover:border-red-300 shadow-sm" data-id="element-189">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0" data-id="element-190" />
              <p className="text-lg text-[#3D2B1F] font-medium" data-id="element-191">{problem}</p>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto text-center space-y-4" data-id="element-192">
          <p className="text-xl text-[#6B5344] font-medium" data-id="element-193">
            La verdad es que la mayoría de las recetas online están mal
            explicadas o incompletas.
          </p>
          <p className="text-xl text-[#9B8578] italic" data-id="element-194">
            Por eso muchas personas terminan frustradas después de intentar
            varias veces.
          </p>
        </div>
      </div>
    </section>;
}